import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { SimpleCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

// Processing some edge-cases when filters were created in legacy UI or via direct API
// calls. And hence its behavior is not consistent with the new UI.
export const improveFilterCondition = (
  condition: SimpleCondition,
  field: IField
): SimpleCondition => {
  if (
    field.filter &&
    (condition.operator === FilterOperator.EQUALS || condition.operator === FilterOperator.IN_ANY)
  ) {
    const isEqualsSupported = field.filter.operators.some(
      ({ operator }) => operator === FilterOperator.EQUALS
    );
    const isInAnySupported = field.filter.operators.some(
      ({ operator }) => operator === FilterOperator.IN_ANY
    );

    if (isInAnySupported && !isEqualsSupported && condition.operator === FilterOperator.EQUALS) {
      return { ...condition, operator: FilterOperator.IN_ANY, value: [condition.value] };
    }

    if (
      isEqualsSupported &&
      !isInAnySupported &&
      condition.operator === FilterOperator.IN_ANY &&
      condition.value.length === 1
    ) {
      return { ...condition, operator: FilterOperator.EQUALS, value: condition.value[0] };
    }
  }

  return condition;
};
